import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap } from 'rxjs/operators';

import { AppActions } from '../../../core/store/actions/app';
import { LinkRequestsPageActions } from '../actions/link-requests';
import { LinkRequestsService } from '../api/link-requests.service';

@Injectable()
export class LinkRequestEffects {
    loadLinkRequestsAfterInitialization$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LinkRequestsPageActions.opened, AppActions.initialized),
                exhaustMap(() => this.linkRequestsService.getLinkRequests()),
            ),
        { dispatch: false },
    );

    constructor(
        private actions$: Actions,
        private linkRequestsService: LinkRequestsService,
    ) {}
}
